// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (max-width:959px){.article-cover .article-byline[data-v-24ce0b06]{font-size:16px}}@media (min-width:960px){.article-cover .article-byline[data-v-24ce0b06]{font-size:18px}}", ""]);
// Exports
module.exports = exports;
